<template>
    <div class="scroll-y custom-scrollbar">
        <ion-row>
            <ion-col size="12" size-md="10" offset-md="1" size-lg="10" offset-lg="1" size-xl="8" offset-xl="2">
                <div class="padding">

                    <form class="form form-set-password" @submit.prevent="setPassword">
                        <h1 class="h1">Ustaw nowe hasło</h1>
                        <div class="form-group">
                            <label>Podaj hasło:</label>
                            <input v-model="form.password" type="password" :class="{'input-error' : errors.password }" placeholder="Podaj hasło" required/>
                            <p class="error" v-if="errors.password">
                                <svg class="voxion"><use xlink:href="#icon-alert"></use></svg>
                                <span v-text="errors.password"></span>
                            </p>
                        </div>
                        <div class="form-group">
                            <label>Powtórz hasło:</label>
                            <input v-model="form.passwordRepeat" type="password" :class="{'input-error' : errors.passwordRepeat }" placeholder="Powtórz hasło" required/>
                            <p class="error" v-if="errors.passwordRepeat">
                                <svg class="voxion"><use xlink:href="#icon-alert"></use></svg>
                                <span v-text="errors.passwordRepeat"></span>
                            </p>
                        </div>
                        <button class="btn btn-primary" type="submit" :disabled=loading>
                            <span v-if="loading"><span class="loader"></span></span>
                            <span v-else>Zapisz</span>
                        </button>
                    </form>

                    <notification v-if="notification" type="success" :text="notificationText"></notification>

                </div>
            </ion-col>
        </ion-row>
    </div>
</template>

<script>
    import api from '@/services/Api';
    import notification from '../../components/Notification'

    export default {
        name: 'SetPassword',
        components: { notification },
        data() {
            return {
                errors: [],
                loading: false,

                notification: false,
                notificationText: '',

                form: {
                    password: '',
                    passwordRepeat: '',
                }
            }
        },
        methods: {
            setPassword() {
                this.loading = true;
                let data = this.form;
                api.post('/api/v1/user/update', data).then(response => {
                    this.loading = false;
                    this.errors = [];
                    if(response.data.success === true){
                        if(response.data.code === 200){
                            this.notification = true;
                            this.notificationText = response.data.message
                        }
                        this.$store.commit('USER_SET_PASSWORD', true);

                        // redirect
                        if(this.$store.getters.getRole === 'salesman') {
                            this.$router.push({ name: 'Index' })
                        }else{
                            // kill me!
                            if(this.$store.getters.showSlider === true){
                                this.$router.push({ name: 'Intro' })
                            }else{
                                this.$router.push({ name: 'Index' })
                            }
                        }
                    }
                }).catch(err => {
                    this.loading = false;
                    this.errors = err.response.data.errors
                })
            }
        }
    }
</script>